type Listener = () => void;

let showRefresh = false;
const listeners = new Set<Listener>();

export const versionStore = {
  getShowRefresh: () => showRefresh,
  setShowRefresh: (val: boolean) => {
    showRefresh = val;
    listeners.forEach((fn) => {
      fn();
    });
  },
  subscribe: (fn: Listener) => {
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  },
};
